type ValuesOf<T> = T[keyof T]

export interface Include<T> {
  included: T[]
}

export interface NewPaginationResponseDto<T> {
  data: T[]
  meta: NewPaginationMeta
}

interface NewPaginationMeta {
  pagination: NewPaginationMetaData
}

interface NewPaginationMetaData {
  size: number
  page: number
  total: number
}

type IncludeParam<T extends string> = [T] extends [never]
  ? never
  : {
      [K in T]: K | `${K},${IncludeParam<Exclude<T, K>>}`
    }[T]

const NewPaginationParamsKeys = {
  page: 'page',
  limit: 'per_page',
} as const
type NewPaginationParamsKeys = (typeof NewPaginationParamsKeys)[keyof typeof NewPaginationParamsKeys]

type NewPaginationParams = {
  [NewPaginationParamsKeys.page]: number
  [NewPaginationParamsKeys.limit]: number
}

export type ConsultationsParamsKeys = ValuesOf<typeof ConsultationsParamsKeys>

export const ConsultationsParamsKeys = {
  FilterByIsClosed: 'filter[is_closed:eq]',
  FilterByIsResolved: 'filter[is_resolved:eq]',
  FilterByProfessional: 'filter[professional:eq]',
  FilterByCustomer: 'filter[customer:eq]',
  FilterByCategory: 'filter[category:eq]',
  Sort: 'sort',
  Include: 'include',
} as const

export const CloseStatus = {
  Open: 'open',
  Resolved: 'resolved',
  Closed: 'closed',
} as const
export type CloseStatus = ValuesOf<typeof CloseStatus>

export const ResolveStatus = {
  Open: 'open',
  Resolved: 'resolved',
  Closed: 'closed',
} as const
export type ResolveStatus = ValuesOf<typeof ResolveStatus>

export const CategoryStatus = {
  OnHold: 'on_hold',
  InProgress: 'in_progress',
  Archived: 'archived',
} as const
export type CategoryStatus = ValuesOf<typeof CategoryStatus>

export const ConsultationIncludes = {
  ConsultationChat: 'consultation_chat',
  Customers: 'customers',
  Professionals: 'professionals',
  ProfessionalsSchedule: 'professionals.schedule',
  Schedules: 'schedules',
  Rooms: 'rooms',
} as const
export type ConsultationIncludes = ValuesOf<typeof ConsultationIncludes>

export type ConsultationsParams = Partial<
  {
    [ConsultationsParamsKeys.FilterByCustomer]: string
    [ConsultationsParamsKeys.FilterByProfessional]: string
    [ConsultationsParamsKeys.FilterByIsClosed]: CloseStatus
    [ConsultationsParamsKeys.FilterByIsResolved]: ResolveStatus
    [ConsultationsParamsKeys.FilterByCategory]: CategoryStatus
    [ConsultationsParamsKeys.Sort]: string
    [ConsultationsParamsKeys.Include]: IncludeParam<ConsultationIncludes>
  } & NewPaginationParams
>
